"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var GenericSnackbar = function (_a) {
    var open = _a.open, onClose = _a.onClose, message = _a.message, _b = _a.severity, severity = _b === void 0 ? "success" : _b, _c = _a.snackbarStyle, snackbarStyle = _c === void 0 ? {} : _c;
    return (react_1.default.createElement(material_1.Snackbar, { open: open, autoHideDuration: 3000, onClose: onClose, anchorOrigin: { vertical: "top", horizontal: "left" }, sx: __assign({ marginLeft: "175px", marginTop: "180px" }, snackbarStyle) },
        react_1.default.createElement(material_1.Alert, { onClose: onClose, severity: severity, variant: "filled", sx: __assign(__assign(__assign(__assign({}, (severity === "success" && {
                backgroundColor: "var(--primary-color) !important",
                color: "#fff",
            })), (severity === "error" && {
                backgroundColor: "var(--error-color) !important",
                color: "#fff",
            })), (severity === "info" && {
                backgroundColor: "var(--info-color) !important",
                color: "#fff",
            })), { fontFamily: "Geomanist", padding: "2px 10px", "& .MuiAlert-icon": {
                    marginRight: "8px",
                    marginTop: "-2px",
                }, "& .MuiAlert-action": {
                    marginLeft: "8px",
                    padding: 0,
                    marginTop: "2px",
                } }) }, message)));
};
exports.default = GenericSnackbar;
